export default "__VITE_ASSET__BwVqEV5R__"